import React from 'react';

const SETTINGS_NAV_ITEMS = [
  { id: 'account-settings', label: 'Account settings' },
  { id: 'venue-details', label: 'Venue details' },
  { id: 'operating-hours', label: 'Operating hours and holidays' },
  { id: 'calendar-sync', label: 'Calendar sync' },
  { id: 'pricing-controls', label: 'Pricing controls' }
];

const SettingsSidebar = ({ activeSubSection, onSubSectionChange, showPayments = false }) => {
  const navItems = showPayments
    ? [...SETTINGS_NAV_ITEMS, { id: 'payments', label: 'Payments' }]
    : SETTINGS_NAV_ITEMS;
  return (
    <div className="settings-sidebar">
      <h3 className="settings-sidebar-title">Settings</h3>
      <div className="settings-nav">
        {navItems.map(item => (
          <button
            key={item.id}
            className={`settings-nav-item ${activeSubSection === item.id ? 'active' : ''}`}
            onClick={() => onSubSectionChange(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SettingsSidebar;

